import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { adminApi } from '../../services/adminApi';

// Exchanges the one-time #session_id from Google sign-in for a session cookie.
export const AuthCallback = () => {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get('session_id');
    adminApi.createSession(sessionId)
      .then((user) => navigate('/admin', { replace: true, state: { user } }))
      .catch((e) => {
        window.history.replaceState(null, '', '/admin');
        setError(e.response?.data?.detail || 'Sign-in failed. Please try again.');
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-red-600 font-semibold mb-4" data-testid="auth-error">{error}</p>
          <a href="/admin" className="text-neutral-900 underline">Back to sign in</a>
        </div>
      ) : (
        <Loader2 className="w-6 h-6 animate-spin text-red-600" />
      )}
    </div>
  );
};
